<template>
  <div class="advert-slot">
    <div class="slot-header">
      <div class="header-left">
        <span class="slot-info"
          >{{ $t("advert-config.AdvertSlotContent.916552-0") }} {{ adverts.length }}
          {{ $t("advert-config.AdvertSlotContent.916552-1") }}</span
        >
        <el-tag v-if="adverts.length > 0" size="mini" type="info" effect="plain">
          {{ advertTypeName }}
        </el-tag>
      </div>
      <el-button
        type="text"
        size="small"
        icon="el-icon-delete"
        @click="$emit('clear', slotKey)"
        v-if="editable && adverts.length > 0"
      >
        {{ $t("advert-config.AdvertSlotContent.916552-2") }}
      </el-button>
    </div>
    <div class="slot-list" v-if="adverts.length > 0">
      <div v-for="(advert, index) in adverts" :key="index" class="slot-item">
        <div class="item-preview">
          <el-image
            v-if="advert.type === 0 || advert.type === '0'"
            :src="advert.url"
            :preview-src-list="[advert.url]"
            fit="cover"
            class="item-image"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div v-else-if="advert.type === 1 || advert.type === '1'" class="item-video-wrapper">
            <video-player
              class="video-player-box vjs-custom-skin"
              :ref="'videoPlayer-' + index"
              :options="getVideoPlayerOptions(advert)"
              :playsinline="true"
            />
          </div>
          <div v-else class="item-other">
            <i class="el-icon-link"></i>
            <span>{{
              advert.type === 2 || advert.type === "2" ? "3D" : $t("advert-config.AdvertSlotContent.916552-4")
            }}</span>
          </div>
        </div>
        <div class="item-info">
          <div class="item-title">{{ advert.head || $t("advert-config.AdvertSlotContent.916552-5") }}</div>
          <div class="item-type">{{ getAdvertTypeName(advert.type) }}</div>
        </div>
        <el-button
          v-if="editable"
          type="text"
          icon="el-icon-close"
          class="item-remove"
          @click="$emit('remove', slotKey, index)"
        />
      </div>
    </div>
    <div v-else class="slot-empty">
      <i class="el-icon-picture-outline"></i>
      <p>{{ emptyText }}</p>
    </div>

    <el-dialog
      :visible.sync="videoPreviewVisible"
      :title="videoPreviewTitle"
      width="70%"
      top="8vh"
      append-to-body
      destroy-on-close
      @close="closeVideoPreview"
    >
      <video v-if="videoPreviewUrl" :src="videoPreviewUrl" controls autoplay class="preview-video-player"></video>
    </el-dialog>
  </div>
</template>

<script>
  import "video.js/dist/video-js.css";
  import { videoPlayer } from "vue-video-player";

  export default {
    name: "AdvertSlotContent",
    components: {
      videoPlayer
    },
    data() {
      return {
        videoPreviewVisible: false,
        videoPreviewUrl: "",
        videoPreviewTitle: ""
      };
    },
    props: {
      adverts: {
        type: Array,
        required: true
      },
      advertTypeName: {
        type: String,
        default: ""
      },
      slotKey: {
        type: String,
        required: true
      },
      editable: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      emptyText() {
        return this.editable ? this.$t("advert-config.AdvertSlotContent.916552-6") : this.$t("common.noData");
      }
    },
    methods: {
      getVideoPlayerOptions(advert) {
        return {
          autoplay: false,
          muted: true,
          loop: false,
          preload: "auto",
          language: "zh-CN",
          fluid: false,
          width: "100%",
          height: "100%",
          sources: [
            {
              type: "video/mp4",
              src: advert.url
            }
          ],
          poster: advert.url + "?x-oss-process=video/snapshot,t_1000,m_fast"
        };
      },
      getAdvertTypeName(type) {
        const typeMap = {
          0: this.$t("advert-config.AdvertSlotContent.916552-7"),
          1: this.$t("advert-config.AdvertSlotContent.916552-8"),
          // 2: this.$t("advert-config.AdvertSlotContent.916552-9"),
          2: this.$t("advert-config.AdvertSlotContent.916552-10")
        };
        return typeMap[String(type)] || this.$t("advert-config.AdvertSlotContent.916552-11");
      },
      previewVideo(advert) {
        if (!advert || !advert.url) {
          return;
        }
        this.videoPreviewUrl = advert.url;
        this.videoPreviewTitle = advert.head || this.$t("advert-config.AdvertSlotContent.916552-8");
        this.videoPreviewVisible = true;
      },
      closeVideoPreview() {
        this.videoPreviewVisible = false;
        this.videoPreviewUrl = "";
        this.videoPreviewTitle = "";
      }
    }
  };
</script>

<style lang="scss" scoped>
  .advert-slot {
    .slot-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
      background: #f5f7fa;
      border-radius: 4px;
      margin-bottom: 12px;

      .header-left {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .slot-info {
        font-size: 14px;
        color: #606266;
      }
    }

    .slot-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
      max-height: 500px;
      overflow-y: auto;
      padding-right: 4px;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: #dcdfe6;
        border-radius: 3px;

        &:hover {
          background: #c0c4cc;
        }
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }
    }

    .slot-item {
      display: flex;
      align-items: center;
      padding: 12px;
      background: #fff;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      transition: all 0.3s;

      &:hover {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      }

      .item-preview {
        width: 80px;
        height: 60px;
        border-radius: 4px;
        overflow: hidden;
        margin-right: 12px;
        flex-shrink: 0;
        background: #f5f7fa;
        display: flex;
        align-items: center;
        justify-content: center;

        .item-image {
          width: 100%;
          height: 100%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;

          ::v-deep .el-image__error {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
          }
        }

        .item-video-wrapper {
          width: 100%;
          height: 100%;

          .video-player-box {
            width: 100%;
            height: 100%;

            ::v-deep .video-js {
              width: 100% !important;
              height: 100% !important;

              .vjs-tech {
                width: 100% !important;
                height: 100% !important;
                object-fit: contain;
              }

              .vjs-big-play-button {
                width: 30px;
                height: 20px;
                font-size: 12px;
                line-height: 20px;
                border-radius: 3px;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }

              .vjs-control-bar {
                width: 100%;
                font-size: 10px;
                height: 20px;

                .vjs-button {
                  font-size: 10px;
                  width: 20px;
                  line-height: 20px;
                }

                .vjs-progress-holder {
                  height: 3px;
                }

                .vjs-volume-panel {
                  display: none;
                }
              }
            }
          }
        }

        .item-video,
        .item-other {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          color: #909399;
          font-size: 12px;

          i {
            font-size: 24px;
            margin-bottom: 4px;
          }
        }

        .image-slot {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          color: #c0c4cc;

          i {
            font-size: 24px;
          }
        }
      }

      .item-info {
        flex: 1;
        overflow: hidden;

        .item-title {
          font-size: 14px;
          font-weight: 500;
          color: #303133;
          margin-bottom: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .item-type {
          font-size: 12px;
          color: #909399;
        }
      }

      .item-remove {
        color: #f56c6c;
        padding: 8px;

        &:hover {
          background: #fef0f0;
        }
      }
    }

    .slot-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 60px 20px;
      color: #909399;
      background: #f5f7fa;
      border-radius: 4px;
      border: 2px dashed #dcdfe6;

      i {
        font-size: 48px;
        margin-bottom: 16px;
        color: #c0c4cc;
      }

      p {
        margin: 0;
        font-size: 14px;
      }
    }
  }

  .preview-video-player {
    width: 100%;
    max-height: 70vh;
    background: #000;
  }
</style>
